import { BillRepository } from "../../repositories/BillRepository";
import { BillOperationResult, BillDataEntity } from "../../entities/BillEntity";

/**
 * Update Bill JSON Use Case
 * Updates bill JSON data (for auto-save and manual edits)
 */
export class UpdateBillJsonUseCase {
  constructor(private repository: BillRepository) {}

  async execute(
    billId: string,
    billData: BillDataEntity
  ): Promise<BillOperationResult> {
    // Validate inputs
    // if (!billId || billId.trim() === "") {
    //   throw new Error("Bill ID is required");
    // }

    // if (!billData) {
    //   throw new Error("Bill data is required");
    // }

    // // Validate required fields in bill data
    // if (!billData.vendor_id || billData.vendor_id.trim() === "") {
    //   throw new Error("Vendor ID is required in bill data");
    // }

    return await this.repository.updateBillJson(billId, billData);
  }
}
